import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import '~shared/components/score-board/score-board.scss';

const EventScore = ({ scores}) => {
    return (
        <>
            {scores.map((score, index) => {
                const isLast = index + 1 === scores.length;
                const { bemModifiers = [], value = '' } = score || {};
                const modifiers = bemModifiers.map(
                    (modifier) => `bb-score-board__score-field--${modifier}`
                );
                const classes = classNames(
                    'bb-score-board__score-field',
                    modifiers,
                    {
                        'bb-score-board__score-field--last-score': isLast,
                    }
                );

                return (
                    <span key={index} className={classes}>
                        {value}
                    </span>
                );
            })}
        </>
    );
};

EventScore.propTypes = {
    scores: PropTypes.array.isRequired,
};

export default EventScore;
